const langDocumentDownloadLogTable = {
	document_name: {
		tag: 'document.download_logs.table.document_name',
		fr: 'Nom du document',
		en: 'Document name',
	},
	document_type: {
		tag: 'document.download_logs.table.document_type',
		fr: 'Type de document',
		en: 'Document type',
	},
	group: {
		tag: 'document.download_logs.table.group',
		fr: 'Groupe',
		en: 'Group',
	},
	fund_type: {
		tag: 'document.download_logs.table.fund_type',
		fr: 'Type de fonds',
		en: 'Funds type',
	},
	access_time: {
		tag: 'document.download_logs.table.access_time',
		fr: 'Téléchargement',
		en: 'Download time',
	},
	release_date: {
		tag: 'document.download_logs.table.release_date',
		fr: 'Date de sortie',
		en: 'Release date',
	},
	user_profile_email: {
		tag: 'document.download_logs.table.user_profile_email',
		fr: 'E-mail',
		en: 'Email',
	},
	download: {
		tag: 'document.download_logs.table.download',
		fr: 'Télécharger',
		en: 'Download',
	},
	view: {
		tag: 'document.download_logs.table.view',
		fr: 'Détail',
		en: 'Detail',
	},
	fund: {
		tag: 'document.download_logs.table.fund',
		fr: 'Nom du fonds',
		en: 'Fund name',
	},
};

export default langDocumentDownloadLogTable;
